import { NavLink } from 'react-router-dom';

import SectionNavigation from '../../components/SectionNavigation';

const threadFamilies = [{ label: 'Metric M', to: '/threads/metric' }];

const ThreadsHeader = () => (
  <SectionNavigation ariaLabel="Threads navigation">
    {threadFamilies.map(({ label, to }) => <NavLink key={to} to={to}>{label}</NavLink>)}
  </SectionNavigation>
);

export default ThreadsHeader;
